import React from "react";

/* ── Image imports (replace with your actual files) ── */
import HeroBgImg   from "../../../asset/images/credentials/hero-bg.webp";
import BcSepIcon   from "../../../asset/images/about/breadcrumb-separator.svg";
import WorldMapImg from "../../../asset/images/credentials/world-map.webp";

/* Certification logo imports */
import CeLogo    from "../../../asset/images/credentials/cert-ce.webp";
import CsaLogo   from "../../../asset/images/credentials/cert-csa.webp";
import Iso1Logo  from "../../../asset/images/credentials/cert-iso1.webp";
import Iso2Logo  from "../../../asset/images/credentials/cert-iso2.webp";
import GostLogo  from "../../../asset/images/credentials/cert-gost.webp";

/* Credential card icon imports */
import Icon1 from "../../../asset/images/credentials/icon-manufacturer.svg";
import Icon2 from "../../../asset/images/credentials/icon-capacity.svg";
import Icon3 from "../../../asset/images/credentials/icon-customers.svg";
import Icon4 from "../../../asset/images/credentials/icon-market-leader.svg";
import Icon5 from "../../../asset/images/credentials/icon-frame.svg";
import Icon6 from "../../../asset/images/credentials/icon-dominance.svg";
import Icon7 from "../../../asset/images/credentials/icon-engineering.svg";
import Icon8 from "../../../asset/images/credentials/icon-certification.svg";
import Icon9 from "../../../asset/images/credentials/icon-technology.svg";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .cr { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .cr-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
  }

  .cr-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .cr-hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to right,
      rgba(0,0,0,0.65) 0%,
      rgba(0,0,0,0.30) 60%,
      rgba(0,0,0,0.08) 100%
    );
  }

  .cr-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px 0px 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }

  .cr-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 20px;
  }

  .cr-hero-divider {
    width: 253px;
    height: 2px;
    background: #EB2019;
    border: none;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .cr-breadcrumb {
    width: 100%;
    padding: 40px 0 0 0;
  }

  .cr-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    gap: 0;
    flex-wrap: wrap;
  }

  .cr-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: color 0.15s;
  }

  .cr-bc-item:hover { color: #EB2019; }

  .cr-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  .cr-bc-sep svg { display: block; }

  .cr-bc-item.active {
    color: #202020;
    font-weight: 500;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .cr-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. CERTIFICATION SECTION
  ══════════════════════════════════════════ */
  .cr-cert-section {
    padding: 80px 0 0 0;
  }

  .cr-cert-row {
    display: flex;
    align-items: center;
    gap: 0;
    border-bottom: 1px solid #E8E8E8;
    padding-bottom: 120px;
  }

  .cr-cert-label-wrap {
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 0 0 200px;
    padding-right: 32px;
  }

  .cr-cert-label {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    line-height: 140%;
    white-space: nowrap;
  }

  .cr-cert-logos {
    display: flex;
    align-items: center;
    gap: 80px;
    padding-left: 59px;
    flex-wrap: wrap;
    border-left: 2px solid #EB2019;
  }

  .cr-cert-logo {
    height: 150px;
    width: auto;
    object-fit: contain;
    display: block;
  }

  /* Placeholder logo circles */
  .cr-cert-logo-placeholder {
    height: 56px;
    width: 56px;
    border-radius: 50%;
    border: 2px solid #E0E0E0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Poppins', sans-serif;
    font-size: 10px;
    font-weight: 600;
    color: #555;
    flex-shrink: 0;
    background: #fff;
  }

  /* ══════════════════════════════════════════
     4. CREDENTIALS GRID
  ══════════════════════════════════════════ */
  .cr-grid-section {
    padding: 80px 0 120px 0;
  }

  .cr-grid-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 60px;
    line-height: 140%;
  }

  .cr-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .cr-card {
    background: #FFF0EF;
    border-radius: 10px;
    padding: 20px 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    min-height: 231px;
  }

  /* Icon white box wrapper */
  .cr-card-icon-wrap {
    width: 84px;
    height: 84px;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .cr-card-icon-wrap img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    display: block;
  }

  .cr-card-text {
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #202020;
    line-height: 160%;
  }

  .cr-card-text strong {
    font-weight: 600;
  }

  /* ══════════════════════════════════════════
     5. WORLD MAP SECTION
  ══════════════════════════════════════════ */
  .cr-map-section {
    padding: 0 0 120px 0;
  }

  .cr-map-img {
    width: 100%;
    max-width: 1200px;
    display: block;
    margin: 0 auto;
    opacity: 0.85;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
  .cr-hero {     height: 350px;}
    .cr-hero-content     { padding: 0 32px 0px 32px; }
    .cr-hero-title       { font-size: 30px; margin-bottom:16px; }
    .cr-hero-divider     { width: 100%; max-width: 200px; }

    .cr-breadcrumb       { padding: 28px 0 0 0; }
    .cr-breadcrumb-inner { padding: 0 32px; }
    .cr-inner            { padding: 0 32px; }

    .cr-cert-section     { padding: 40px 0 0 0; }
    .cr-cert-row         { flex-direction: column; align-items: flex-start; gap: 20px; padding-bottom: 40px; }
    .cr-cert-label-wrap  { border-right: none; border-bottom: 2px solid #EB2019; padding-right: 0; padding-bottom: 12px; flex: none; }
    .cr-cert-logos       { padding-left: 0; gap: 32px; border:none; }
    .cr-cert-logo {
    height: 110px;
    width: auto;
    object-fit: contain;
    display: block;
}
 .cr-grid-section {
    padding: 48px 0 48px 0;
}
    .cr-grid             { grid-template-columns: repeat(2, 1fr); }
    .cr-grid-title       { font-size: 32px;    margin-bottom: 24px; }
  }
    .cr-map-section { padding: 0 0 48px 0;}

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 480px)
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .cr-hero             { height: 400px; }
    .cr-hero-content     { padding: 16px; justify-content: center; }
    .cr-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .cr-hero-divider     { width: 100%; max-width: 240px; margin-bottom: 12px; }

    .cr-breadcrumb       { padding: 32px 0 0 0; }
    .cr-breadcrumb-inner { padding: 0 16px; gap:14px;}
    .cr-bc-item          { font-size: 14px; gap: 8px; }
    .cr-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .cr-inner            { padding: 0 16px; }

    .cr-cert-section     { padding: 60px 0 0 0; }
    .cr-cert-label { font-size:20px; }
    .cr-cert-logos       { column-gap: 57px !important; row-gap: 24px !important; }
    .cr-cert-logo        { height: 84px; }
    .cr-cert-logo-placeholder { height: 44px; width: 44px; }

    .cr-grid-section     { padding: 60px 0 60px 0; }
    .cr-grid             { grid-template-columns: 1fr; gap: 30px; }
    .cr-grid-title       { font-size: 20px; margin-bottom: 20px; }
    .cr-card             { padding: 20px ; min-height: unset; gap: 15px;}
        .cr-cert-row { padding-bottom:60px;}
        .cr-card-text { font-size:14px;}
        .cr-card-icon-wrap {     width: 64px; height: 64px;}
        .cr-map-section { padding: 0 0 60px 0;}
    
  }
`;

/* Breadcrumb separator arrow (reused from About page) */
const BcArrow = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M2 1l3 3-3 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const credentials = [
  { icon: Icon1, text: "Largest HVR manufacturer in the world, covering all ratings" },
  { icon: Icon2, text: "Manufacturing capacity of over 2400 sets annually" },
  { icon: Icon3, text: "200+ customers • 20,000+ installations Presence in 82 countries across 6 continents" },
  { icon: Icon4, text: "Market leader since 1978 in Core-sector industries, Power, Steel, Cement, Pulp & Paper." },
  { icon: Icon5, text: "Frame agreement with Global EPC giants like GE-Power, FL Smidth for worldwide supplies" },
  { icon: Icon6, text: "Dominance in Global power sector" },
  { icon: Icon7, text: "In-house engineering & design capabilities" },
  { icon: Icon8, text: "Certification of CE, CSAC-US, GOST-R, IS, ISO 9001:2015, ISO 14001:2015" },
  { icon: Icon9, text: "Technology tie-up with Redkoh USA for Precipitator Controls" },
];

export default function Credentials() {
  return (
    <div className="cr">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="cr-hero">
        <img className="cr-hero-bg" src={HeroBgImg} alt="Credentials Hero" />
        <div className="cr-hero-overlay" />
        <div className="cr-hero-content">
          <h1 className="cr-hero-title">Credentials</h1>
          <hr className="cr-hero-divider" />
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="cr-breadcrumb" aria-label="Breadcrumb">
        <div className="cr-breadcrumb-inner">
          <a href="/" className="cr-bc-item">Home</a>
          <span className="cr-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/about-us" className="cr-bc-item">About Us</a>
          <span className="cr-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="cr-bc-item active">Credentials</span>
        </div>
      </nav>

      {/* ══ 3. CERTIFICATION ROW ══ */}
      <section className="cr-cert-section">
        <div className="cr-inner">
          <div className="cr-cert-row">
            <div className="cr-cert-label-wrap">
              <span className="cr-cert-label">Certification</span>
            </div>
            <div className="cr-cert-logos">
              <img className="cr-cert-logo" src={CeLogo} alt="CE Certification" />
              <img className="cr-cert-logo" src={CsaLogo} alt="CSA Certification" />
              <img className="cr-cert-logo" src={Iso1Logo} alt="ISO Certification" />
              <img className="cr-cert-logo" src={Iso2Logo} alt="ISO Certification" />
              <img className="cr-cert-logo" src={GostLogo} alt="GOST-R Certification" />
            </div>
          </div>
        </div>
      </section>

      {/* ══ 4. CREDENTIALS GRID ══ */}
      <section className="cr-grid-section">
        <div className="cr-inner">
          <h2 className="cr-grid-title">Credentials</h2>
          <div className="cr-grid">
            {credentials.map((item, idx) => (
              <div className="cr-card" key={idx}>
                <div className="cr-card-icon-wrap">
                  <img src={item.icon} alt="" />
                </div>
                <p className="cr-card-text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 5. WORLD MAP ══ */}
      <section className="cr-map-section">
        <div className="cr-inner">
          <img className="cr-map-img" src={WorldMapImg} alt="Global Presence Map" />
        </div>
      </section>

    </div>
  );
}